import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/configs/app.config';
import { ChartData } from '../chart/interfaces/chart-data';
import { ActivityPriorityService } from '../http/activity-priority/activity-priority.service';
import { ActivityPriorityType } from '../http/activity-priority/enums/activity-priority-type';

@Injectable({ providedIn: 'root' })
export class PriorityChartMapperService {
  constructor(private activityPriorityService: ActivityPriorityService) {}

  private priorityChartMetricNameMap: Record<number, string> = {
    [ActivityPriorityType.NormalActivity]: 'countNormal',
    [ActivityPriorityType.AdvertiseActivity]: 'countAdvertise',
    [ActivityPriorityType.OptionalRoster]: 'countOptionalRoster',
    [ActivityPriorityType.RegularRoster]: 'countRegularRoster',
    [ActivityPriorityType.PriorityRoster]: 'countPriorityRoster',
    [ActivityPriorityType.AdminMustAttend]: 'countAdminMustAttend'
  };

  async getPriorityChartData(): Promise<Record<string, ChartData>> {
    const priorities = await this.activityPriorityService.getAll().toPromise() ?? [];

    const chartData: Record<string, ChartData> = {};

    for (const priority of priorities) {
      const metricName = this.priorityChartMetricNameMap[priority.type];

      if (metricName) {
        const backgroundColor = AppConfig.PriorityTypeColorMapping[priority.type];
        chartData[metricName] = { label: priority.title, backgroundColor };
      }
    }

    return chartData;
  }
}
